export const PLUS_PRICING_SECTION_ID = 'plus-pricing'

/** PostHog events fired by the /plus page CTAs. */
export const PLUS_POSTHOG_EVENTS = {
  /** CTAs that scroll to the pricing section (hero banner, bottom conversion section). */
  VIEW_PLANS: 'plus_view_plans',
  /** Pricing section CTA that opens the market checkout. */
  TRIAL_CLICK: 'plus_trial_click',
} as const
